export { default as Form } from 'notifications_config/components/form/NotificationConfigForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/form/index.js